<template>
  <base-slide-over ref="filterSlideover" title="Filter Diputes" size="lg" style="z-index: 10000">
    <base-form ref="form" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" @submit.prevent>
      <div class="tw-text-normal tw-font-normal tw-mt-6 tw-mb-2.5">Status</div>
      <base-advanced-select label="Status" placeholder="Select one or more status" :options="statusOptions" v-model="statusFilter" label-key="label" multiple />
    </base-form>
    <template #fixed-bottom>
      <div class="tw-p-3 tw-flex tw-justify-between">
        <base-button type="flat" color="red" class="tw-w-auto tw-mr-2" @click="clearFilters">
          Clear All
        </base-button>
        <div>
          <base-button type="flat" class="tw-w-auto tw-mr-2" @click="$refs.filterSlideover.hide()">
            Cancel
          </base-button>
          <base-button class="tw-w-auto" @click="applyFilter">
            Apply
          </base-button>
        </div>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
export default {
  name: "DisputeFilter",
  props: {
    businessId: { type: String },
  },
  components: {},
  data() {
    return {
      statusFilter: [],
      statusOptions: [
        { label: "Lost", value: "lost" },
        { label: "Needs response", value: "needs_response" },
        { label: "Under review", value: "under_review" },
        { label: "Warning - Closed", value: "warning_closed" },
        { label: "Warning - Needs response", value: "warning_needs_response" },
        { label: "Warning - Under review", value: "warning_under_review" },
        { label: "Won", value: "won" },
      ],
    };
  },
  methods: {
    show() {
      this.$refs.filterSlideover.show();
    },
    hide() {
      this.$refs.filterSlideover.hide();
    },
    clearFilters() {
      this.reset();
      this.applyFilter();
    },
    reset() {
      this.statusFilter = [];
    },
    applyFilter() {
      let statusFilterStrings = this.statusFilter.map(function(item) {
        return item["value"];
      });

      this.$emit("filter-updated", {
        statusFilter: statusFilterStrings,
      });

      this.hide();
    },
  },
};
</script>
